import {
	FormField,
	MultiSelectOptions,
} from '@dealstack/frontend/shared/components/Documents/FormFields/types';
import { SearchSelectWithNestedCollapsableChildrenOptions } from '@dealstack/frontend/shared/components/forms/SearchSelectWithNestedCollapsableChildren/SearchSelectWithNestedCollapsableChildren.types';

// helper function to check if a field has options
export const hasOptions = (
	field: FormField
): field is FormField & {
	options: MultiSelectOptions[] | SearchSelectWithNestedCollapsableChildrenOptions[] | string[];
} => {
	return 'options' in field && Array.isArray(field.options);
};

//  map field options for SearchSelectWithNestedCollapsableChildren
export const mapFieldOptions = (
	field: FormField
): SearchSelectWithNestedCollapsableChildrenOptions[] => {
	if (!hasOptions(field)) {
		return [];
	}

	return (
		field.options as (
			| MultiSelectOptions
			| SearchSelectWithNestedCollapsableChildrenOptions
			| string
		)[]
	).map((option) => {
		if (typeof option === 'string') {
			return { value: option, label: option };
		}
		if ('children' in option) {
			return option as SearchSelectWithNestedCollapsableChildrenOptions;
		}
		return { value: option.value, label: option.label };
	});
};
